import { supportedHomePages } from '../types';

export const isHomePage = (homePageSlug: string) => supportedHomePages.includes(homePageSlug);
